<template>
    <div>
        <h2 class="text-uppercase my-4">{{ t('clientsDeletion-total_stats-title') }}</h2>

        <div class="row stats">
            <div class="col-12 ">
                <div class="row w-100">
                    <div class="col-sm-12 col-md-4">
                        <div class="box">
                            <div class="icon">
                                <Icon icon-class="ui-user-01" size="13" />
                            </div>
                            <div class="info">
                                <div class="label">
                                    <strong>{{ t('clientsDeletion-total_stats-clients') }}</strong>
                                </div>
                                <div class="number">
                                    {{ stats.total - stats.leadCount }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-12 col-md-4">
                        <div class="box">
                            <div class="icon">
                                <Icon icon-class="ui-cursor-click-01" size="13" />
                            </div>
                            <div class="info">
                                <div class="label">
                                    <strong>{{ t('clientsDeletion-total_stats-leads') }}</strong>
                                </div>
                                <div class="number">
                                    {{ stats.leadCount }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-12 col-md-4">
                        <div class="box">
                            <div class="icon">
                                <Icon icon-class="ui-users-01" size="13" />
                            </div>
                            <div class="info">
                                <div class="label">
                                    <strong>{{ t('clientsDeletion-total_stats-total') }}</strong>
                                </div>
                                <div class="number">
                                    {{ stats.total }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Icon from "../components/icon/icon";
export default {
    components: {
        Icon
    },
    props: {
        stats: {
            type: Object,
            required: true
        }
    },
    methods: {
        t: function (term, replaces) {
            return this.$root.t(term, replaces);
        },
    },
};
</script>
